import { render, staticRenderFns } from "./condicionesEstructurales.vue?vue&type=template&id=36a90b19&scoped=true&"
import script from "./condicionesEstructurales.vue?vue&type=script&lang=js&"
export * from "./condicionesEstructurales.vue?vue&type=script&lang=js&"
import style0 from "./condicionesEstructurales.vue?vue&type=style&index=0&id=36a90b19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a90b19",
  null
  
)

export default component.exports